export default __webpack_public_path__ + "static/media/2020 (5).9e2cb00a.jpg";